<template>
  <div class="consume">
    <navigation-bar Back/>
    <div class="main">
      <div class="top_main">
        <div class="title">{{ data.brandName }}</div>
        <div class="number" v-if="data.invoiceNumber !== ''">{{ data.invoiceNumber }}</div>
        <div class="branch" v-if="data.storeName !== ''">{{ data.storeName }}</div>
        <div class="status" v-if="data.invoiceNumber !== '0' && data.invoiceNumber !== '' ">發票狀態-{{
          data.invoiceStatus
          }}
        </div>
      </div>

      <ul class="sub_info">
        <li>
          <img src="@/assets/images/icon-scan-pay.svg">
          <span class="w_red">{{ data.invoicePrice }}</span>
        </li>
        <li>
          <img src="@/assets/images/icon-date.svg">
          <span class="w_red">{{ data.date }}</span>
        </li>
        <li>
          <img src="@/assets/images/icon-time.svg">
          <span class="w_red">{{ data.time }}</span>
        </li>
      </ul>

      <div class="cost_list">
        <!--todo 線上點餐要出現以下這個div-->
        <div class="text-center bg-yellow" v-if="data.isOnlineOrder">線上點餐</div>
        <div class="text-center bg-yellow" v-else-if="data.isPosReserve">線上預訂</div>
        <ul>
          <li><b class="main_dish">消費明細</b></li>
          <template v-for="(item,index) in data.goods">

            <!--todo 合併結帳用-帳務明細-->
            <li class="bg-brown d-flex" :key="index" v-if="(index=== 0 || item.isOtherTableOrder) && data.isMergedOrder">
              <span class="text">帳務明細-{{item.tableName}}桌</span>
              <span class="fee">$ {{mergedOrderTotalPrice(index)}}</span>
            </li>

            <li :key="index">
              <div v-if="item.type === 0">
              <span class="main_dish">{{ item.name }}{{ item.amount > 1 ? '(X' + item.amount + ')' : '' }}
                <span class="cost">$ {{ item.totalPrice }}</span>
              </span>
                <div v-for="(good,index) in item.combo" :key="index+'gd'">
                  <span class="sub">$ {{ good.name }}</span>
                </div>
              </div>
              <div v-else-if="item.type === 1">
              <span class="main_dish">{{ item | reserveFormat }}
                <span class="cost">$ {{ item.totalPrice }}</span>
              </span>
              </div>
              <div v-else-if="item.type === 2">
              <span class="main_dish">{{ item.name }}
                <span class="cost">$ {{ item.totalPrice }}</span>
              </span>
              </div>
              <!--todo 購物車項目-->
              <div v-else-if="item.type === 3" class="mb-2">
              <span class="main_dish mb-0">{{ item.name }}
                <span class="cost">$ {{ item.totalPrice }}</span>
              </span>
                <div v-for="combo in item.combo" :key="combo.id" class="ml-1">
                  <span v-if="combo.type === 1" class="small">[{{combo.kindName}}] {{combo.name}} {{combo.amount}} 張</span>
                  <span v-if="combo.type === 2" class="small">[禮包] {{combo.name}}</span>
                  <div v-for="content in combo.contentList" :key="content.id">
                    <span class="small ml-2">. [{{content.kindName}}] {{content.name}} {{content.amount}} 張</span>
                  </div>
                </div>
              </div>
            </li>
          </template>

          <li v-for="(item,index) in data.free" :key="index+'free'">
          <span class="main_dish">招待-{{ item.name }}
            <span class="cost">$ {{ item.price }}</span>
          </span>
          </li>

        </ul>


        <ul class="count_list">
          <li>
            <span class="count mb-4">小計
                <span class="cost">$ {{ data.subPrice }}</span>
            </span>
          </li>
          <li>
            <span class="count" v-if="data.freePrice !== null && data.freePrice !== 0 ">招待
              <span class="cost">- $ {{ data.freePrice }}</span>
            </span>
          </li>
          <li>
            <div v-for="(item,index) in data.cardList" :key="index+'card'">
            <span class="count">{{item.cardName}}-{{item.cardDiscountContent}}
              <span class="cost">- $ {{item.cardDiscount}}</span>
            </span>
            </div>
            <div v-for="(item,index) in data.discount" :key="index+'discount'">
            <span class="count" style="color:#7B7B7B">{{item.name}} {{'(X' + item.amount + ')'}}
              <span class="cost">{{(item.couponType === "freebie" || item.couponType === "reserveFreebie" ? "" : (item.couponType === "addPurchase" ? "+" : "-"))}} $ {{item.totalPrice}}</span>
            </span>
            </div>
            <div v-for="(item,index) in data.otherDiscount" :key="index+'other'">
            <span class="count">{{ item.name || "手動折價" }} {{'(X' + item.amount + ')'}}
              <span class="cost">- $ {{ item.price }}</span>
            </span>
            </div>
            <div v-for="(item,index) in data.useRewardPointList" :key="index+'useRewardPoint'">
                    <span class="count">{{ item.name }} (X{{item.usePoint}}點)
                    <span class="cost"> - $ {{ item.amount }}</span>
                </span>
            </div>
          </li>
        </ul>
        <ul class="count_list">
          <li>
          <span class="main_dish"><span class="red">優惠合計</span>
              <span class="cost red">{{ data.totalDiscount >= 0 ? '-' : '+'}} $ {{ data.totalDiscount >= 0 ? data.totalDiscount : data.totalDiscount * -1}}</span>
          </span>
            <span class="count">扣除優惠總計
              <span class="cost">$ {{ (0 > (data.subPrice - data.totalDiscount) ? 0 : data.subPrice - data.totalDiscount) }}</span>
          </span>
            <span class="count" v-if="data.isOnlineOrder">外送費
              <span class="cost">$ {{ data.deliveryFee }}</span>
            </span>
            <span class="count" v-else>
              <template v-if="data.tip!==0">
                服務費
                <span class="cost">$ {{ data.tip }}</span>
              </template>
            </span>
          </li>
        </ul>
        <ul class="count_list">
          <li>
            <span class="count"><b>應付金額</b>
                <span class="cost">$ {{ data.totalPrice }}</span>
            </span>
          </li>
        </ul>
      </div> <!--end of cost_list-->
      <div class="shadow-line"></div>
      <div class="cost_list payment">
        <ul>
          <li><span class="main_dish"><b>支付方式</b></span></li>
          <li v-for="(item,index) in data.payment" :key="index+'p'">
          <span v-if="item.totalPrice" class="main_dish">{{ item.name }}{{item.cardNumber !== "" ? ` (${item.cardNumber})` : ""}} {{ item.amount > 1 ? '(X' + item.amount + ')' : '' }}
              <span class="cost">$ {{ item.totalPrice }}</span>
          </span>
          </li>
          <li class="w_red">
             <span class="main_dish"><span class="red">發票金額</span>
                  <span class="cost red">$ {{ data.invoicePrice }}</span>
              </span>
          </li>
        </ul>

      </div> <!--end of cost_list-->
      <div class="shadow-line"></div>
      <div class="coupon_list" v-bind:class="(data.gift != null && data.gift.length > 0)? 'mb-5':''"
           v-if="data.gift != null && data.gift.length > 0">
        <ul class="word_list">
          <li>
            <span class="main_dish"><b>贈送優惠</b></span>
          </li>
          <li v-for="(item,index) in data.gift" :key="index+'gift'">
              <span class="main_dish">{{ item.name }}：{{ item.amount >= 1 ? item.amount + '張' : '' }}
                   <span class="cost"></span>
              </span>
          </li>
        </ul>
      </div> <!--end of coupon_list-->
      <div class="img_list" v-if="data.gift != null && data.gift.length > 0 && !isWeb">
        <ul>
          <li v-for="(item,index) in data.gift" :key="index+'gift'">
            <div @click="$router.push({name: 'CouponPage' , query :{id:item.id,couponId:item.couponId} })">
              <el-image class="img" :src="item.imageLink" fit="cover">
                <div slot="error" class="image-slot"/>
              </el-image>
              <div class="title">{{ item.name }}</div>
            </div>
          </li>
        </ul>
      </div> <!--end of img_list-->

      <!--    <div class="shadow-line"></div>-->

      <div class="coupon_list" v-bind:class="(data.loyaltyCardAmountList != null && data.loyaltyCardAmountList.length > 0)? 'mb-5':''"
           v-if="data.loyaltyCardAmountList != null && data.loyaltyCardAmountList.length > 0">
        <ul class="word_list">
          <li>
            <span class="main_dish"><b>獲得集點卡點數</b></span>
          </li>
          <li v-for="(item,index) in data.loyaltyCardAmountList" :key="index+'gift'">
              <span class="main_dish">{{ item.name }}：{{ item.amount >= 1 ?   item.amount + '點' : '' }}
                   <span class="cost"></span>
              </span>
          </li>
        </ul>

      </div> <!--end of coupon_list-->
      <div class="img_list" v-if="data.loyaltyCardAmountList != null && data.loyaltyCardAmountList.length > 0 && !isWeb">
        <ul>
          <li v-for="(item,index) in data.loyaltyCardAmountList" :key="index+'gift'">
            <div @click="$router.push({name: 'LoyaltyCardPage', query:{id: item.loyaltyCardListId, 'activeCategory': 'loyaltyCard'}})">
              <el-image class="img" :src="item.titleImage" fit="cover">
                <div slot="error" class="image-slot"/>
              </el-image>
              <div class="title">{{ item.name }}</div>
            </div>
          </li>
        </ul>
      </div> <!--end of img_list-->

      <div class="coupon_list" v-bind:class="(data.sendRewardPointList != null && data.sendRewardPointList.length > 0)? 'mb-5':''"
           v-if="data.sendRewardPointList != null && data.sendRewardPointList.length > 0">
        <ul class="word_list">
          <li>
            <span class="main_dish"><b>獲得紅利點數</b></span>
          </li>
          <li v-for="(item,index) in data.sendRewardPointList" :key="index+'gift'">
              <span class="main_dish">{{ item.name }}：{{ item.point >= 1 ?   item.point + '點' : '' }}
                   <span class="cost"></span>
              </span>
          </li>
        </ul>

      </div>
      <div class="img_list" v-if="data.sendRewardPointList != null && data.sendRewardPointList.length > 0  && !isWeb">
        <ul>
          <li v-for="(item,index) in data.sendRewardPointList" :key="index+'gift'">
            <div @click="goRewardPoint(item)">
              <el-image class="img" :src="item.titleImage" fit="cover">
                <div slot="error" class="image-slot"/>
              </el-image>
              <div class="title">{{ item.name }}</div>
            </div>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import crypto from "@/util/crypto";
import router from "@/router";

export default {
  name: 'HistoryContent',
  props: {
    isWeb: Boolean,
    orderSnWeb: {default: 0},
  },
  data() {
    return {
      orderSn: 0,
      data: {},
      openType: ''
    }
  },
  created() {

    if (!this.isWeb){
      if (this.$route.params.orderSn === undefined || this.$route.params.orderSn === '') {
        this.$router.go(-1);
      }
    }

    if (!this.isWeb){
      this.orderSn = this.$route.params.orderSn;
    } else {
      //單店網頁版用
      this.orderSn = this.orderSnWeb;
    }

    this.openType = this.$route.params.openType ? this.$route.params.openType : '';
    this.setUp();
  },
  methods: {
    setUp() {
      this.$http.fetchWithAuth`GetOrder${{
        'orderSn': this.orderSn,
      }}
        ${json => {
        if (json.data !== null && json.data !== '') {
          this.data = json.data;
          if (this.openType === 'fmt'){
            if(Array.isArray(this.data.gift)) {
              this.data.gift.forEach((item) => {
                this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', ['coupon', item.couponId]);
              });
            }
            if(Array.isArray(this.data.loyaltyCardAmountList)) {
              this.data.loyaltyCardAmountList.forEach((item) => {
                this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', ['loyaltyCard', item.loyaltyCardListId]);
              });
            }
          }
        }
      }
      }}`;
    },
      goRewardPoint(item) {
          let dataToken = crypto.objectToURIComponent({
              "usedType":  "BonusPointsPage",
              "id":        item.id,
          })

          this.$router.push({name: 'BonusPointsPage', query: {dataToken: dataToken}})
      },
  },
  filters: {
    reserveFormat(item) {
      let unit = "";
      switch(item.intervalType) {
        case 1:
          unit = "分鐘"
          break;
        case 2:
          unit = "小時"
          break;
        case 3:
          unit = "天"
          break;
      }

      return `${item.name} $${item.intervalPrice} 每${item.intervalUnit}${unit}` + (item.amount > 1 ? `(X${item.amount})` : ``);
    },
  },
    computed: {
        mergedOrderTotalPrice() {
            return index => {
                let totalPrice = 0;
                for (let i = index; i < this.data.goods.length; i++) {
                    if (i !== index && this.data.goods[i].isOtherTableOrder) {
                        break;
                    } else {
                        totalPrice += this.data.goods[i].totalPrice;
                    }
                }
                return totalPrice
            }
        }
    }
}
</script>
<style lang="less" scoped src="../../../less/history.less"/>